
import { defineComponent } from 'vue'
import Dialog from 'primevue/dialog'
import KpiDocumentDesignerSaveDialogDescriptor from './KpiDocumentDesignerSaveDialogDescriptor.json'

export default defineComponent({
    name: 'kpi-edit-save-dialog',
    components: { Dialog },
    props: { visible: { type: Boolean } },
    emits: ['close', 'saveKpi'],
    data() {
        return {
            KpiDocumentDesignerSaveDialogDescriptor,
            kpiName: ''
        }
    },
    computed: {
        saveButtonDisabled(): boolean {
            return this.kpiName.length === 0
        }
    },
    created() {},
    methods: {
        close() {
            this.kpiName = ''
            this.$emit('close')
        },
        saveKpi() {
            this.$emit('saveKpi', this.kpiName)
        }
    }
})
